import React, { useEffect } from "react";
import styled from "styled-components";
import ArchivePageNavigation from "archive/components/ArchivePageNavigation";
import connect from "stores/connect";
import { Row, Col } from "components/bootstrap";
import { DocumentTitle, PageHeader, Spinner } from "components/common";
import withParams from "routing/withParams";
import AppConfig from "util/AppConfig";
import ArchiveActions from "archive/ArchiveActions";
import ArchiveBackendsStore, { ArchiveBackendsActions } from "archive/ArchiveBackendsStore";
import ArchivePageHeaderSupport from "archive/components/ArchivePageHeaderDescription";
import ArchiveBackendConfigForm from "archive/components/ArchiveBackendConfigForm";
import useHistory from "routing/useHistory";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { LICENSE_SUBJECTS } from "license/constants";
import LicenseCheck from "license/LicenseCheck";
import { ARCHIVE_LICENSE_WARNING_TITLE, ARCHIVE_LICENSE_WARNING_TEXT } from "archive/constants";
import ArchiveRoutes from "./Routes";
const isCloud = AppConfig.isCloud();
const StyledH2 = styled.h2`
  margin-bottom: 10px;
`;
const ArchiveBackendConfigurationPage = ({
  params,
  backend = {
    id: void 0,
    title: "",
    description: "",
    settings: {
      type: void 0
    }
  }
}) => {
  const { backendId } = params;
  const history = useHistory();
  const sendTelemetry = useSendTelemetry();
  useEffect(() => {
    if (backendId) {
      ArchiveBackendsActions.getBackend(backendId);
    }
  }, [backendId]);
  if (isCloud) {
    history.push(ArchiveRoutes.BACKENDS.LIST);
  }
  const _isLoading = backendId && !(backend == null ? void 0 : backend.id);
  if (_isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const _checkOutputPath = (path) => ArchiveActions.checkOutputTemplate(path);
  const _updateConfiguration = (backendUpdate) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.ARCHIVE[`BACKEND_CONFIGURATION_${(backendUpdate == null ? void 0 : backendUpdate.id) ? "UPDATED" : "CREATED"}`], {
      app_pathname: "archive",
      app_section: "backend-configuration",
      event_details: { backend_type: backendUpdate.settings.type }
    });
    return ArchiveBackendsActions.saveBackend(backendUpdate).then(() => {
      history.push(ArchiveRoutes.BACKENDS.LIST);
    });
  };
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Archive backend configuration" }, /* @__PURE__ */ React.createElement(ArchivePageNavigation, null), /* @__PURE__ */ React.createElement(PageHeader, { title: "Edit archive backend configuration" }, /* @__PURE__ */ React.createElement(ArchivePageHeaderSupport, null)), /* @__PURE__ */ React.createElement(
    LicenseCheck,
    {
      text: ARCHIVE_LICENSE_WARNING_TEXT,
      title: ARCHIVE_LICENSE_WARNING_TITLE,
      licenseSubject: LICENSE_SUBJECTS.archive,
      displayWarningContainer: true,
      bsStyle: "danger"
    }
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { lg: 8 }, /* @__PURE__ */ React.createElement(StyledH2, null, "Backend configuration"), /* @__PURE__ */ React.createElement(
    ArchiveBackendConfigForm,
    {
      backend,
      checkOutputPath: _checkOutputPath,
      updateConfiguration: _updateConfiguration,
      submitButtonText: backendId ? "Update backend" : "Create backend",
      submitLoadingText: backendId ? "Updating backend" : "Creating backend",
      cancelURL: ArchiveRoutes.BACKENDS.LIST
    }
  ))));
};
export default withParams(
  connect(
    ArchiveBackendConfigurationPage,
    { archiveBackends: ArchiveBackendsStore },
    ({ archiveBackends, ...otherProps }) => ({
      ...otherProps,
      backend: archiveBackends.backend
    })
  )
);
